import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  LOGIN_INPUT_COLOR,
  SELECT_ITEM_BORDER_COLOR,
  BUTTON_BG_COLOR
} = constants;

let styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%'
  },
  item: {
    padding: 10,
    width: '50%',
    boxSizing: 'border-box'
  },
  innerItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${SELECT_ITEM_BORDER_COLOR}`,
    padding: 40,
    borderRadius: 5
  },
  selected: {
    borderColor: BUTTON_BG_COLOR
  },
  icon: {
    marginBottom: 10,
    fontSize: 24,
    color: LOGIN_INPUT_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/selectgrid/SelectGrid.styles.js